import { supabase } from '@/lib/supabase'
import type { Client } from '@/types/domain'

export const clientsRepo = {
  async findAll(): Promise<Client[]> {
    const { data, error } = await supabase
      .from('clients')
      .select('*')
      .order('created_at', { ascending: false })

    if (error) throw error
    return (data || []) as Client[]
  },

  async findById(id: string): Promise<Client | null> {
    const { data, error } = await supabase
      .from('clients')
      .select('*')
      .eq('id', id)
      .single()

    if (error) throw error
    return data as Client
  },

  async create(client: any): Promise<Client> {
    const { data: { user } } = await supabase.auth.getUser()
    
    const { data, error } = await supabase
      .from('clients')
      .insert({ ...client, created_by: user?.id } as any)
      .select()
      .single()

    if (error) throw error
    return data as Client
  },

  async update(id: string, updates: any): Promise<Client> {
    const { data, error } = await supabase
      .from('clients')
      .update(updates as never)
      .eq('id', id)
      .select()
      .single()

    if (error) throw error
    return data as Client
  },

  async delete(id: string): Promise<void> {
    console.log('Attempting to delete client:', id)

    const { error } = await supabase
      .from('clients')
      .delete()
      .eq('id', id)

    if (error) {
      console.error('Delete client error details:', {
        message: error.message,
        details: error.details,
        hint: error.hint,
        code: error.code,
      })
      throw new Error(`Failed to delete client: ${error.message}${error.hint ? ` (${error.hint})` : ''}`)
    }

    console.log('Client deleted successfully')
  },
}
